import { AxiosResponse } from 'axios';
import apiService from './api';

export interface AiChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AiNavItem {
  title: string;
  link: string;
  subItems?: AiNavItem[];
}

export type AiChatRow = Record<string, unknown>;

export interface AiChatResponse {
  answer: string;
  sql?: string;
  /** Rows the query returned (capped server-side). */
  rows?: AiChatRow[];
  /** Total rows the query returned, which can exceed `rows.length`. */
  rowCount?: number;
}

export const sendAiChat = (
  question: string,
  history: AiChatMessage[],
  conversationId: string,
  navigation: AiNavItem[],
): Promise<AxiosResponse<AiChatResponse>> => {
  return apiService.post<
    {
      question: string;
      history: AiChatMessage[];
      conversationId: string;
      navigation: AiNavItem[];
    },
    AiChatResponse
  >('/ai/chat', { question, history, conversationId, navigation });
};

export interface AiChatLog {
  id: string;
  askedAt: string;
  conversationId: string | null;
  schoolId: string | null;
  schoolName: string | null;
  outcome: string | null;
  userId: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  role: string | null;
  question: string;
  answer: string | null;
  sql: string | null;
  wasAnswered: boolean;
  durationMs: number | null;
}

export interface AiChatLogsResponse {
  logs: AiChatLog[];
  total: number;
}

export const getAiChatLogs = (
  page: number,
  limit: number
): Promise<AxiosResponse<AiChatLogsResponse>> => {
  return apiService.get<AiChatLogsResponse>('/ai/chat-logs', { page, limit });
};
